import ButtonOnce from './ButtonOnce.vue'

export default function (Vue, options = {}) {
    window.buttonOnceDefaults = Object.assign({
        waitFor: 2500,
        clickText: null,
    }, options);

    Vue.component('button-once', ButtonOnce);
}
